<template>
  <div class="page page-minimal">
    <div class="navbar minimal-nav d-flex justify-content-center align-items-center my-3">
      <div class="navbar-brand">
        <img v-if="event && event.branding && event.branding.logo && event.branding.logo.fileLocation"
          :src="event.branding.logo.fileLocation"/>
        <img v-else-if="company && company.siteBranding && company.siteBranding.bigLogo && company.siteBranding.bigLogo.fileLocation"
          :src="company.siteBranding.bigLogo.fileLocation"/>
        <img v-else-if="company && company.siteBranding && company.siteBranding.smallLogo && company.siteBranding.smallLogo.fileLocation"
          :src="company.siteBranding.smallLogo.fileLocation"/>
        <h2 v-else-if="event && event.title">{{ event.title }}</h2>
        <h2 v-else-if="company && company.name">{{ company.name }}</h2>
        <h2 v-else>&nbsp;</h2>
      </div>
    </div>

    <b-container v-if="statuses.length">
      <status-bar v-for="(status, i) in statuses" :key="i" class="my-3" :status="status"/>
    </b-container>

    <b-container fluid>
      <b-row class="share-show-page my-3">
        <b-col cols="12" class="text-center" v-if="this.applicationFormURL && !this.applyThenRedirect">
          <p><a :href="this.applicationFormURL">{{ $t('shareshow.redirecting-you') }}</a></p>
        </b-col>
        <b-col cols="12" v-else-if="$apollo.loading" class="d-flex flex-row justify-content-center align-items-center">
          <b-spinner label="Loading" variant="primary"/>
        </b-col>
        <b-col v-else-if="enableSingleUseLinks && job && job.customFieldsHash && job.customFieldsHash.singleUseLink && application" cols="12">
          <b-alert show variant="info" class="text-center">{{ $t('shareshow.sorry-expired') }}</b-alert>
        </b-col>
        <b-col v-else-if="job && job.id && job.status === 'ACTIVE'" cols="12" md="8" offset-md="2">
          <b-card body-class="my-3 p-3">
            <h3>{{ job.title }}</h3>

            <key-stats class="py-3" v-if="job" :job="job" hide-referral-bonus/>
            <!-- img v-if="job.image" class="job-image" :src="job.image"/ -->

            <markdown v-if="showFullDescription" class="job-description" :source="job.description"
              :anchorAttributes="markdownAnchorAttributes"/>
            <p class="job-description" v-else-if="job.excerpt">{{ job.excerpt }}</p>

            <div class="d-flex flex-row justify-content-center align-items-center">
              <b-btn @click.prevent="() => showFullDescription = !showFullDescription" size="sm" variant="link">
                {{ showFullDescription ? $t('jobs.ctas.hide-description') : $t('jobs.ctas.show-description') }}
              </b-btn>
            </div>

            <!-- <template v-if="company && isDiageo && Array.isArray(company.contentShares) && company.contentShares.length">
              <hr class="my-5"/>
              <h2 class="mb-3">Relevant content</h2>

              <b-row class="card-deck">
                <b-col class="mb-3" cols="12" sm="6" v-for="(entry, i) in company.contentShares" :key="`item-${entry.id}-${i}`">
                  <content-card :entry="entry" hide-footer/>
                </b-col>
              </b-row>
            </template> -->
          </b-card>

          <b-card no-body>
            <b-card-header class="text-center mb-3 bg-primary-a2 d-flex flex-row justify-content-start align-items-center"
              v-if="user && !(canEmployeeApply && currentUser)">
                <avatar class="mr-3" :user="user" :size="50"/>
                <p class="m-0"><b>{{ $t('shareshow.want-to-work-with') }} {{user.fullName}}?</b></p>
            </b-card-header>
            <b-card-body>
              <h3 v-if="!applyThenRedirect" class="mb-3 border-bottom">{{ $t('shareshow.apply-now') }}</h3>
              <div v-else class="mb-3 border-bottom">
                <h3>{{ $t('shareshow.apply-now') }}</h3>
                <template v-if="user && !(canEmployeeApply && currentUser && currentUser.id === user.id)">
                  <p v-if="isIdemia" class="mb-2 help-text">{{ $t('shareshow.please-share1') }} <strong>{{ user.fullName || "person referred" }}</strong>. When you click ‘Continue to Apply’, you will be redirected to Idemia’s job page to complete your application.</p>
                  <p v-else class="mb-2 help-text">{{ $t('shareshow.please-share1') }} <strong>{{ user.fullName || "person referred" }}</strong>. {{ $t('shareshow.please-share2') }}</p>
                  <p v-if="displayCustomShareShowMessage" class="help-text custom-instructions-alert"><b>{{ $t('shareshow.custom-instructions') }}</b></p>
                  <p v-else class="help-text"><b>{{ $t('shareshow.use-same-address') }}</b></p>
                </template>
              </div>

              <template v-if="applyThenRedirect && applyResult === true">
                <p v-if="applicationFormURL"><a :href="applicationFormURL">{{ $t('shareshow.redirecting-you') }}</a></p>
                <p v-else>{{ $t('shareshow.thanks1') }}</p>
              </template>
              <template v-else-if="isProductMadness && applyResult === true">
                <p>Hi {{ applyForm.fullName }},</p>
                <p>Thank you for applying to the {{ job.title }} position.</p>
                <p>I'd like to inform you that we received your application. Our hiring team is currently reviewing all applications and we are planning to schedule interviews shortly. If you are among qualified candidates, you will receive a call or email from one of our recruiters to discuss further.</p>
                <p>In any case, we will keep you posted on the status of your application.</p>
                <p>Thank you, again, for taking the time to apply to this role.</p>
                <p>Best regards,<br/>The TA Team</p>
              </template>
              <template v-else-if="applyResult === true">
                <p>Your application has been submitted.</p>
                <p>Thanks for applying!</p>
              </template>
              <template v-else>
                <b-alert show variant="danger" v-if="applyResult === 'ERR-ALREADY-EXISTS'">
                  {{ $t('shareshow.error-dupe') }}
                </b-alert>
                <b-alert show variant="danger" v-else-if="typeof applyResult === 'string'">
                  {{ $t('shareshow.sorry-error') }}
                </b-alert>

                <no-ssr>
                  <advanced-form autocomplete="off" :form="applyFormFields" v-model="applyForm"
                    :submit-label="applicationFormURL ? $t('shareshow.continue-apply') : $t('shareshow.apply-now')" @submit="applySubmit">
                      <template v-if="firstCustomFieldID" v-slot:[`${firstCustomFieldID}-before`]><hr/></template>

                      <!-- Product Madness integration requires a phone number prefix to be chosen from the list -->
                      <template v-if="isProductMadness" v-slot:phoneNumber-input-group-prepend>
                        <b-form-select :options="pmPhoneCodeRefs" :style="{ width: '170px' }" v-model="pmPhoneCodeRef">
                          <template v-slot:first>
                            <option disabled :value="null">Choose (+00)</option>
                          </template>
                        </b-form-select>
                      </template>

                      <template v-if="greenhouseEducationRequired" v-slot:[`${greenhouseEducationSlot}-after`]>
                        <hr/>
                          <greenhouse-education-questions
                            :jobBoardToken="job.atsData.jobBoardToken"
                            v-model="applyGreenhouseEducationAnswers"/>
                        <hr/>
                      </template>

                      <template
                        v-for="question in (customApplyQuestions || [])"
                        v-slot:[`custom-${question.id}-label`]
                      >
                        <div :key="question.id">
                          <template v-if="question.label === hispanicQuestion.id">
                            <span :key="question.id"><strong>If you selected 'No' in the previous question, please identify your race.</strong></span>
                          </template>
                          <template v-else>
                            <strong v-html="`${question.label}${question.required ? '*' : ''}`"></strong>
                            <div
                              v-if="question.description"
                              v-html="replaceDescription(question.description)">
                            </div>
                          </template>
                        </div>
                      </template>

                      <!--template
                        v-for="question in (customApplyQuestions || []).filter(({ description }) => description)"
                        v-slot:[`custom-${question.id}-description`]
                      >
                        <div v-html="question.description" :key="question.id"></div>
                      </template -->

                      <template
                        v-for="questionID in (Array.isArray(firstSetQuestionIDs) ? firstSetQuestionIDs : [])"
                        v-slot:[`custom-${questionID}-before`]
                      >
                        <div :key="`${questionID}-before`">
                          <h3 v-if="(questionSets.find(({ id }) => id === ((customApplyQuestions || []).find(({ id }) => id === questionID) || {}).setID) || {}).title">
                            {{(questionSets.find(({ id }) => id === ((customApplyQuestions || []).find(({ id }) => id === questionID) || {}).setID) || {}).title}}
                          </h3>
                          <markdown
                            v-if="(questionSets.find(({ id }) => id === ((customApplyQuestions || []).find(({ id }) => id === questionID) || {}).setID) || {}).description"
                            :source="(questionSets.find(({ id }) => id === ((customApplyQuestions || []).find(({ id }) => id === questionID) || {}).setID) || {}).description"
                            :anchorAttributes="markdownAnchorAttributes"
                            :prerender="renderHTML"
                          />
                        </div>
                      </template>

                      <template
                        v-for="question in (customApplyQuestions || [])"
                        v-slot:[`custom-${question.id}-after`]
                      >
                        <div :key="`after-${question.id}`">
                          <div
                            class="mb-3"
                            v-if="otherFields.map(({ id }) => id).includes(question.label)
                              && (applyForm || {})[`custom-${question.id}`]
                              && ((otherFields.find(({ id }) => id === question.label) || {}).value || []).includes(applyForm[`custom-${question.id}`])"
                          >
                            <small>Please describe below if prefer to self-describe</small><br>
                            <b-input v-model="applyForm[`custom-${question.id}-other`]" />
                          </div>
                          <div v-else-if="question.label === 'DisabilityStatus'">
                            PUBLIC BURDEN STATEMENT: According to the Paperwork Reduction Act of 1995 no persons are required to respond to a collection of information unless such collection displays a valid OMB control number. This survey should take about 5 minutes to complete.
                          </div>
                        </div>
                      </template>

                      <template
                        v-for="question in (customApplyQuestions || []).filter(({ label }) => label === hispanicQuestion.id)"
                        v-slot:[`custom-${question.id}-before`]
                      >
                        <div :key="question.id" class="mb-3">
                          <b-form-group label="Are you Hispanic/Latino?">
                            <b-form-select v-model="(applyForm || {})[`custom-${question.id}`]">
                              <b-form-select-option value="Hispanic or Latino">Yes</b-form-select-option>
                              <b-form-select-option :value="null">No</b-form-select-option>
                              <b-form-select-option :value="''">Decline to self identify</b-form-select-option>
                            </b-form-select>
                          </b-form-group>
                        </div>
                      </template>

                      <!-- Temporary solution for Capco -->
                      <template v-if="applyFormFields.capcoTerms" v-slot:capcoTerms-before>
                        <h4 class="pt-3 mt-3 border-top">{{ applyFormFields.capcoTerms.label }}</h4>
                        <div v-html="applyFormFields.capcoTerms.description"></div>
                      </template>
                      <template v-if="applyFormFields.capcoTerms" v-slot:capcoTerms-description>
                        <div>{{ applyFormFields.capcoTerms.choices ?
                            applyFormFields.capcoTerms.choices[Object.keys(applyFormFields.capcoTerms.choices)[0]] :
                            'Acknowledge/Confirm'
                        }}</div>
                      </template>
                      <template v-if="applyFormFields.capcoTerms" v-slot:capcoTerms-label>
                        <div></div>
                      </template>

                      <template v-slot:termsAgreed-description>
                        <i18n path="applications.labels.termsAgreed-visitor">
                          <template v-slot:termsConditionsLink>
                            <a :href="$t('urls.terms-conditions')" tabindex="-1" target="_blank">{{ $t('general.terms-conditions') }}</a>
                          </template>
                          <template v-slot:privacyPolicyLink>
                            <a :href="$t('urls.privacy-policy')" tabindex="-1" target="_blank">{{ $t('general.privacy-policy') }}</a>
                          </template>
                        </i18n>
                      </template>
                      <template v-slot:termsAgreed-invalid-feedback>
                        <div class="invalid-feedback d-inline">{{ $t('applications.validation.termsAgreed-unchecked') }}</div>
                      </template>
                  </advanced-form>
                </no-ssr>
              </template>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col v-else cols="12">
          <b-alert show variant="info" class="text-center">{{ $t('shareshow.sorry-closed') }}</b-alert>
        </b-col>

        <b-modal v-if="this.job && this.user && this.referral"
          :title="`${this.user.fullName} has invited you to apply for ${this.job.title}`" title-class="text-center"
          hide-header-close no-close-on-backdrop no-close-on-esc no-stacking ok-only ok-title="Continue"
          :visible="!referralGdprAgreed" @ok="agreeToGdpr">
            <p>Please click Continue below to view the job and confirm you understand how Real Links Limited processes your personal data in accordance
              with their Privacy Policy which you can <a href="https://www.reallinks.io/privacy-policy/" target="_blank">click here</a> to view.
              If you wish to opt out of any further processing, please email us at <a href="mailto:data@reallinks.io">data@reallinks.io</a>.</p>
        </b-modal>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HeaderBlock from '@/components/Header';
import HeaderMinimalBlock from '@/components/Header-minimal';
import Avatar from '@/components/users/Avatar';
import GreenhouseEducationQuestions from '@/components/jobs/GreenhouseEducationQuestions';
import qs from 'querystring';
import Markdown from 'vue-markdown';
import Page from '@/components/Page';
import KeyStats from '@/components/jobs/key-stats';
import ContentCard from '@/components/content-share/ContentCard';
import ShareShowQuery from '@/graphql/queries/ShareShow.gql';
import JobShowQuery from '@/graphql/queries/JobShow.gql';
import JobApplicationCreateMutation from '@/graphql/mutations/JobApplicationCreate.gql';
import AdvancedForm from '@/components/AdvancedForm';
import { unescape } from 'html-escaper';
import { createVueMetaBranding } from '@src/lib/branding';
import { mapRoot, mapPreferences } from '@/mixins/root';
import { StatusBar } from '@src/components/Statuses';
import { tryNull, matchGraphQLError } from '@/lib/utils';
import gql from 'graphql-tag';
import { getStatusesForRoute } from '@/lib/status';
import { pmPhoneCodeOptions, pmPhonePrefixMap } from '@/components/success/pm-phoneCodeRefs';

const TrackingCodeQuery = gql`
  query TrackingCode(
    $userID: ID!,
    $eventID: ID!
  ) {
    company {
      id
      event(where: { id: $eventID }) {
        id
        campaign {
          id
          trackingCode(where:{ id: $userID })
        }
      }
    }
  }
`;

const localStorage = 'localStorage' in global && global.localStorage ? global.localStorage : null;

const otherFields = [
  { id: 'Please indicate your gender identity', value: [ '4106569003', '4106611003', '4106580003' ] },
  { id: 'Please indicate your sexual orientation', value: [ '4106575003', '4106606003' ] },
];
const hispanicQuestion = { id: 'Race' };

export default {
  components: {
    Page,
    HeaderBlock,
    HeaderMinimalBlock,
    Avatar,
    AdvancedForm,
    Markdown,
    KeyStats,
    ContentCard,
    StatusBar,
    GreenhouseEducationQuestions,
  },
  data: () => ({
    fatalErr: null,
    showFullDescription: false,
    hasLoggedVisit: false,
    referralGdprAgreed: false,
    applyForm: null,
    applyResult: null,
    applyGreenhouseEducationAnswers: null,
    pmPhoneCodeRef: null,
  }),
  created() {
    if (localStorage && this.contactID) {
      this.referralGdprAgreed = Boolean(localStorage.getItem(`rlnx-share-gdpr-agreed:${this.contactID}`));
    }
  },
  async mounted() {
    if (process.env.VUE_ENV === 'client') {
      if (this.job && this.user && !this.hasLoggedVisit) {
        this.onReady();
      }
    }
  },
  beforeRouteUpdate(to) {
    // this.shareCode = to.params.code;
    this.fatalErr = null;
  },
  apollo: {
    company: {
      query() {
        const { jobCode } = this.$route.params;
        return jobCode ? JobShowQuery : ShareShowQuery;
      },
      variables() {
        const { shareCode, jobCode, eventID } = this.$route.params;
        return {
          shareCode,
          jobID: jobCode,
          withEvent: Boolean(eventID),
          eventID,
        };
      },
      async result({ loading, data }) {
        if (!loading && data && data.company && data.company.id) {
          if (process.env.VUE_ENV === 'client' && !this.hasLoggedVisit) {
            this.onReady();
          }
        }
      },
      error(err) {
        this.$log.error(err);
        if (!this.job) {
          this.fatalErr = 'Job not found';
        }
      },
      prefetch: true,
    },
    trackingCode: {
      query() {
        return TrackingCodeQuery;
      },
      variables() {
        const { userID, eventID } = this;
        return {
          userID,
          eventID,
        };
      },
      update({ company }) {
        if (company && company.id && company.event && company.event.campaign && company.event.campaign.trackingCode) {
          return company.event.campaign.trackingCode;
        }
        return null;
      },
      error(err) {
        this.$log.error(err);
      },
      skip() {
        return !this.userID || !this.eventID;
      },
    },
  },
  metaInfo() {
    const canonical = `${this.$root.origin}${this.$route.fullPath}`;

    const head = {
      title: 'Referrals',
      meta: [],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: canonical },
      ],
      script: [],
    };

    if (this.company) {
      const companyName = (this.company.siteBranding && this.company.siteBranding.name) || this.company.name;

      if (companyName) {
        head.meta.push({ vmid: 'author', name: 'author', content: companyName });
        head.meta.push({ vmid: 'og:author', name: 'og:author', content: companyName });
        head.meta.push({ vmid: 'og:site_name', property: 'og:site_name', content: companyName });
        // twitter:site => @reallinksio
      }
    }

    if (this.event && this.event.id) {
      if (this.event.branding) {
        const isAdminUI = process.env.VUE_ENV === 'server' ? false : process.env.ADMIN_UI;
        const nonce = process.env.VUE_ENV === 'server' ? (this.$ssrContext.nonce || '') : '';
        createVueMetaBranding.call(this, head, this.event.branding, { isAdminUI, nonce });
      }
    }

    if (this.job) {
      head.meta.push({ vmid: 'og:url', property: 'og:url', content: canonical });

      if (this.job.title) {
        head.title = this.job.title;
        head.meta.push({ vmid: 'og:title', property: 'og:title', content: this.job.title });
        head.meta.push({ vmid: 'twitter:title', property: 'twitter:title', content: this.job.title });
      }

      if (this.job.excerpt) {
        head.meta.push({
          vmid: 'description',
          property: 'description',
          content: this.job.excerpt,
        });

        head.meta.push({
          vmid: 'og:description',
          property: 'og:description',
          content: this.job.excerpt,
        });
      }

      // article:modified_time -> updated at?
      // article:expiration_time -> expiry time?

      if (this.applicationFormURL) {
        // Since we will soon redirect to an external URL, set a suitable Referrer-Policy
        head.meta.push({ vmid: 'referrer', name: 'referrer', content: 'unsafe-url' });

        if (!this.applyThenRedirect) {
          // Since we're about to redirect to an external URL, disable customJS here
          head.script.push({ vmid: 'customJS', innerHTML: null });
        }
      }
    }

    if (this.job && this.job.image) {
      head.meta.push({
        vmid: 'og:image',
        property: 'og:image',
        content: this.job.image,
      });
      head.meta.push({
        vmid: 'twitter:image',
        name: 'twitter:image',
        content: this.job.image,
      });
    } else if (this.event && this.event.branding && this.event.branding.socialImage && this.event.branding.socialImage.fileLocation) {
      head.meta.push({
        vmid: 'og:image',
        property: 'og:image',
        content: this.event.branding.socialImage.fileLocation,
      });
      head.meta.push({
        vmid: 'twitter:image',
        name: 'twitter:image',
        content: this.event.branding.socialImage.fileLocation,
      });
    } else if (this.company && this.company.siteBranding && this.company.siteBranding.socialImage && this.company.siteBranding.socialImage.fileLocation) {
      head.meta.push({
        vmid: 'og:image',
        property: 'og:image',
        content: this.company.siteBranding.socialImage.fileLocation,
      });
      head.meta.push({
        vmid: 'twitter:image',
        name: 'twitter:image',
        content: this.company.siteBranding.socialImage.fileLocation,
      });
    }

    return head;
  },
  computed: {
    ...mapRoot([ 'isAssurant', 'isBRC', 'isChalhoub', 'isEXPD8', 'isEY', 'isGWRReferrals', 'isIdemia', 'isProductMadness', 'isThales' ]),
    ...mapRoot({ currentUser: 'user' }),
    ...mapPreferences([ 'applyWithResume', 'applyWithCoverLetter', 'applyWithLocation', 'canEmployeeApply', 'displayApplyTermsAndConditions', 'displayCustomShareShowMessage', 'useApplicationForwardedEvent', 'applyWithPhoneNumber', 'enableSingleUseLinks' ]),
    otherFields: () => otherFields,
    hispanicQuestion: () => hispanicQuestion,
    /**
     * Enabled if the customer wants us to take candidate details before redirecting them to their ATS
     * @return {boolean}
     */
    applyThenRedirect() {
      const { customFieldsHash } = { ...this.job };
      const { applyThenRedirect } = { ...customFieldsHash };
      return this.applicationFormURL && applyThenRedirect === true;
    },
    markdownAnchorAttributes: () => ({
      // Open all hyperlinks in the Markdown block in a new tab
      target: '_blank',
      // Enforce a nofollow to avoid SEO backlash from private content
      rel: 'nofollow',
    }),
    statuses() {
      return getStatusesForRoute(this.$route).filter(status => status && status.type === 'bar');
    },
    job() {
      return this.company && this.company.job && this.company.job.id ? this.company.job : null;
    },
    application() {
      return !!(this.enableSingleUseLinks && this.company && this.company.applicationConnections && this.company.applicationConnections.edges && this.company.applicationConnections.edges.length);
    },
    jobID() {
      return this.job && this.job.id ? this.job.id : null;
    },
    event() {
      return this.company && this.company.event && this.company.event.id ? this.company.event : null;
    },
    eventID() {
      const defaultEventID = this.company && this.company.referral && this.company.referral.event &&
        this.company.referral.event.id ? this.company.referral.event.id : null;
      return this.event && this.event.id ? this.event.id : defaultEventID;
    },
    referral() {
      return this.company && this.company.referral && this.company.referral.id ? this.company.referral : null;
    },
    referralID() {
      return this.referral && this.referral.id ? this.referral.id : null;
    },
    user() {
      return this.company && this.company.user && this.company.user.id ? this.company.user : null;
    },
    userID() {
      return this.user && this.user.id ? this.user.id : null;
    },
    contactID() {
      return this.referral && this.referral.contact && this.referral.contact.id ? this.referral.contact.id : null;
    },
    applicationFormURL() {
      const { customFieldsHash } = { ...this.job };
      let { applicationFormURL: applyURL } = { ...customFieldsHash };

      if (typeof applyURL === 'string') {
        const { hostname, origin } = this.$root;
        const { path } = this.$route;

        const { shareCode } = this.$route.params;
        const { jobID, referralID, userID, trackingCode, isEY, isBRC, isEXPD8, isGWRReferrals, isChalhoub } = this;

        const replacements = {
          hostname,
          'url': `${origin}${path}`,
          shareCode,
          jobID,
          userID,
          'referralID': referralID || '',
        };

        if (isEXPD8 || isGWRReferrals) {
          applyURL = `${applyURL}&_referrerid=${shareCode}`;
        }

        if (isChalhoub) {
          applyURL = `${applyURL}?utm_source=RealLinks-${shareCode}`;
        }

        if (isBRC) {
          applyURL = `${applyURL}?influencetoapply=reallinks&influencetoapplydescription=${shareCode}`;
        }

        if (isEY && jobID === 'mDZ3O' && trackingCode) {
          return trackingCode;
        }

        const queryExtension = trackingCode && !trackingCode.includes('http') ? trackingCode : '';
        return Object.keys(replacements).reduce((str, key) => str.replace(`{${key}}`, replacements[key]), `${applyURL}${queryExtension}`);
      } else {
        return null;
      }
    },
    questionSets() {
      const { customFieldsHash } = { ...this.job };
      const { questionSets } = { ...customFieldsHash };
      if (!questionSets) return null;
      try {
        const sets = Array.isArray(JSON.parse(questionSets)) ? JSON.parse(questionSets) : [];
        console.log({ sets });
        return sets;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    firstSetQuestionIDs() {
      const { questionSets } = this;
      const { customApplyQuestions } = this || {};
      if (!(Array.isArray(customApplyQuestions) && customApplyQuestions.length)) return null;
      if (!(Array.isArray(questionSets) && questionSets.length)) return null;
      return questionSets
        .filter(({ id }) => ![ undefined, null, 'custom_questions' ].includes(id))
        .map(({ id }) => (customApplyQuestions.find(({ setID }) => id === setID) || {}).id)
        .filter(el => el);
    },
    customApplyQuestions() {
      const { questionSets } = this;
      const { customApplyQuestions } = this.job || {};
      if (!(Array.isArray(customApplyQuestions) && customApplyQuestions.length)) return null;
      if (!(Array.isArray(questionSets) && questionSets.length)) return customApplyQuestions;
      console.log({ customApplyQuestions });
      return [
        undefined,
        null,
        'custom_questions',
        ...questionSets.map(({ id }) => id).filter(el => el !== 'custom_questions')
      ].reduce((res, id) => [ ...res, ...customApplyQuestions.filter(({ setID }) => setID === id) ], []);
    },
    applyFormFields() {
      const form = {
        fullName: {
          label: this.$t('users.labels.fullName'),
          placeholder: this.$t('applications.placeholders.fullName'),
          required: true,
          type: 'STRING',
          defaultValue: (this.canEmployeeApply && this.currentUser) ? `${this.currentUser.firstName} ${this.currentUser.lastName}` : undefined,
          validation: {
            minLength: 3,
          },
        },
        emailAddress: {
          label: this.$t('users.labels.emailAddress'),
          placeholder: this.$t('applications.placeholders.emailAddress'),
          required: true,
          type: 'STRING',
          defaultValue: (this.canEmployeeApply && this.currentUser) ? this.currentUser.emailAddress : undefined,
          options: {
            autocomplete: 'off',
          },
          validation: {
            isEmailAddress: true,
          },
        },
        ...((this.applyWithPhoneNumber) ? {
          phoneNumber: {
            label: this.$t('users.labels.phoneNumber'),
            placeholder: this.$t('applications.placeholders.phoneNumber'),
            type: 'STRING',
            defaultValue: (this.canEmployeeApply && this.currentUser) ? this.currentUser.phoneNumber : undefined,
            options: {
              autocomplete: 'off',
            },
            validation: {
              isPhoneNumber: true,
            }
          }
        } : {}),
        ...((typeof this.applyThenRedirect === 'boolean' && this.applyThenRedirect && this.isThales) ? {
          linkedInURL: {
            label: 'LinkedIn Profile URL',
            placeholder: 'https://www.linkedin.com/in/...',
            type: 'STRING',
            options: {
              autocomplete: 'off',
            },
          },
        } : {}),
        ...(typeof this.applyWithResume === 'boolean' ? {
          resume: {
            label: 'Resume',
            placeholder: 'Select a resume',
            required: this.applyWithResume,
            type: 'FILE',
            options: {
              type: 'DOCUMENT',
            },
          },
        } : {}),
        ...(typeof this.applyWithCoverLetter === 'boolean' ? {
          coverLetter: {
            label: 'Cover Letter',
            placeholder: 'Select a cover letter',
            type: 'FILE',
            required: this.applyWithCoverLetter,
            options: {
              type: 'DOCUMENT',
            },
          },
        } : {}),
        ...(typeof this.applyWithLocation === 'boolean' && this.applyWithLocation ? {
          location: {
            label: 'Your Location (City)',
            placeholder: 'London',
            type: 'STRING',
            required: true,
          },
        } : {}),
      };

      if (this.canEmployeeApply && this.currentUser) {
        const { firstName, emailAddress, phoneNumber } = this.currentUser;
        form.fullName.disabled = Boolean(firstName);
        form.emailAddress.disabled = Boolean(emailAddress);
        if (form.phoneNumber) {
          form.phoneNumber.disabled = Boolean(phoneNumber);
        }
      }

      if (this.isProductMadness && form.phoneNumber) {
        // Product Madness would like phone number to be a required field
        form.phoneNumber.placeholder = 'e.g. 7500123456';
        form.phoneNumber.required = true;
      }

      const { customApplyQuestions } = this || {};
      const customQuestions = Array.isArray(customApplyQuestions)
        ? customApplyQuestions
          // @TODO temporary tweak for CAPCO
          .filter(({ label }) => label !== 'Capco Job Candidate Privacy Notice Acknowledgement')
          .map(el => {
            if (el.type === 'FILE') {
              el.options = {
                type: 'DOCUMENT',
              };
            }
            return el;
          })
          .reduce((qs, { id, ...field }) => ({ ...qs, [`custom-${id}`]: field }), {})
        : null;

      // @TODO temporary tweak for CAPCO
      const capcoTerms = (customApplyQuestions || []).find(
        ({ label }) => label === 'Capco Job Candidate Privacy Notice Acknowledgement'
      );

      if (this.applyThenRedirect) {
        delete form.resume;
        delete form.coverLetter;
      }

      console.log({ customApplyQuestions });

      return {
        ...form,
        ...(customQuestions || {}),
        // @TODO temporary tweak for CAPCO
        ...(capcoTerms ? { capcoTerms } : {}),
        ...(this.displayApplyTermsAndConditions ? {
          termsAgreed:
          {
            description: 'By ticking this, you agree to our Terms & Conditions and Privacy Policy',
            required: true,
            type: 'CHECKBOX',
            options: {
              type: 'DOCUMENT',
            },
          },
        } : {}),
      };
    },
    firstCustomFieldID() {
      const { job } = this;
      if (job && job.id && Array.isArray(job.customApplyQuestions) && job.customApplyQuestions.length) {
        const [ { id } ] = job.customApplyQuestions;
        return `custom-${id}`;
      }

      return null;
    },
    greenhouseEducationRequired() {
      const { atsData } = this.job || {};
      const { education } = atsData || {};
      return education === 'education_required';
    },
    greenhouseEducationSlot() {
      if (typeof this.applyWithLocation === 'boolean' && this.applyWithLocation) {
        return 'location';
      }
      if (typeof this.applyWithCoverLetter === 'boolean') {
        return 'coverLetter';
      }
      if (typeof this.applyWithResume === 'boolean') {
        return 'resume';
      }
      return 'phoneNumber';
    },
    pmPhoneCodeRefs() {
      return this.isProductMadness ? pmPhoneCodeOptions : null;
    },
  },
  methods: {
    async onReady() {
      // if (localStorage) {
      //   const referrer = tryNull(() => document.referrer);
      //   if (referrer && !localStorage.getItem('rlnx-share-referer')) {
      //     localStorage.setItem('rlnx-share-referer', referrer);
      //   }
      // }

      // If we've got the job & user, and no-referrer or has already agreed to GDPR
      if (this.job && this.user && (!this.referral || this.referralGdprAgreed)) {
        // Log the visit
        await Promise.resolve(this.logShareVisit()).catch(err => this.$log.error(err));
        // Optionally redirect to the ATS
        setTimeout(() => {
          this.applicationFormURL && this.redirectToATS();
        }, 1500);
        // this.applicationFormURL && this.redirectToATS();
      }

      // console.log({
      //   canEmployeeApply: this.canEmployeeApply,
      //   currentUser: this.currentUser,
      //   userID: this.userID
      // });

      if (this.canEmployeeApply && this.currentUser && this.currentUser.id === this.userID) {
        const { firstName, lastName, emailAddress, phoneNumber } = this.currentUser;
        // console.log({ firstName, lastName, emailAddress, phoneNumber });
        this.applyForm = {
          fullName: `${firstName} ${lastName}`,
          emailAddress,
          phoneNumber,
        };
      }
    },
    async agreeToGdpr() {
      this.referralGdprAgreed = true;
      if (localStorage && this.contactID) {
        localStorage.setItem(`rlnx-share-gdpr-agreed:${this.contactID}`, (new Date()).toISOString());
      }

      // Log the visit
      await Promise.resolve(this.logShareVisit()).catch(err => this.$log.error(err));
      // Optionally redirect to the ATS
      this.applicationFormURL && this.redirectToATS();
    },
    logShareVisit() {
      this.hasLoggedVisit = true;

      const canonical = `${this.$root.origin}${this.$route.fullPath}`;

      const logShareVisited = {
        eventName: this.referralID ? 'REFERRAL_VISITED' : 'SHARE_VISITED',
        job: this.jobID ? { id: this.jobID } : undefined,
        user: this.userID ? { id: this.userID } : undefined,
        referral: this.referralID ? { id: this.referralID } : undefined,
        event: this.eventID ? { id: this.eventID } : undefined,
        data: { canonical, shareCode: this.shareCode },
      };

      const { location, navigator } = window;

      const pushDataProperty = (key, ...getters) => {
        if (getters.length) {
          const value = tryNull(getters.shift());
          if (value) {
            logShareVisited.data[key] = value;
          } else {
            pushDataProperty(key, ...getters);
          }
        }
      };

      pushDataProperty('acceptLanguage', () => navigator.userLanguage, () => navigator.language);
      pushDataProperty('referer', () => document.referrer);
      pushDataProperty('userAgent', () => navigator.userAgent);

      if (location && location.search) {
        const QUERY_STRINGS_TO_RECORD = [ 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign' ];
        const query = qs.parse(location.search);
        QUERY_STRINGS_TO_RECORD.filter(key => query.hasOwnProperty(key)).forEach(key => {
          key = key.replace(/[^a-zA-Z0-9-]/g, '-').replace(/[-]+/g, '-').replace(/^[-]/, '').replace(/[-]$/, '');
          logShareVisited.data[key] = query[key] || null;
        });
      }

      if (this.job.status !== 'ACTIVE') {
        logShareVisited.eventName = 'INACTIVE_JOB_VISITED';
        logShareVisited.data = {
          ...logShareVisited.data,
          applicationFormURL: this.applicationFormURL || null,
          status: this.job.status,
        };
      }

      return this.$root.captureLog(logShareVisited);
    },
    redirectToATS(force = false) {
      return this.applicationFormURL && (force === true || !this.applyThenRedirect)
        ? Boolean(window.location = this.applicationFormURL)
        : false;
    },
    async applySubmit() {
      try {
        const { fullName, emailAddress, phoneNumber, linkedInURL, resume, coverLetter, location, termsAgreed } = this.applyForm;

        this.$assert(this.jobID, 'Expected jobID to be set');
        this.$assert((resume && resume.id) || this.applyWithResume !== true,
          'Expected resume to be attached');
        this.$assert((coverLetter && coverLetter.id) || this.applyWithCoverLetter !== true,
          'Expected coverLetter to be attached');
        this.$assert(location || this.applyWithLocation !== true,
          'Expected location to be filled');

        const customAnswers = Array.isArray(this.job.customApplyQuestions) && this.job.customApplyQuestions.length
          ? this.job.customApplyQuestions.reduce((answers, field) => {
            const { id: questionID, type } = field;
            const { [`custom-${questionID}`]: answer } = this.applyForm;
            if (type === 'FILE' && answer && answer.id) {
              return answers.concat({ questionID, file: { id: answer.id } });
            } else if (Array.isArray(answer)) {
              return answers.concat({ questionID, values: answer });
            } else if (answer) {
              return answers.concat({ questionID, value: answer });
            } else if (field.label === 'Capco Job Candidate Privacy Notice Acknowledgement') {
              return answers.concat({ questionID, value: this.applyForm.capcoTerms ? 'true' : false });
            } else {
              return answers;
            }
          }, [])
          : [];

        if (this.greenhouseEducationRequired) {
          this.$assert(Array.isArray(this.applyGreenhouseEducationAnswers) && this.applyGreenhouseEducationAnswers.length,
            'Expected education information to be entered');
          customAnswers.push({
            questionID: 'GREENHOUSE-EDUCATION',
            value: JSON.stringify(this.applyGreenhouseEducationAnswers),
          });
        }

        const { shareCode } = this.$route.params;

        const create = {
          job: { id: this.jobID },
          user: this.userID ? { id: this.userID } : undefined,
          referral: this.referralID ? { id: this.referralID } : undefined,
          event: this.eventID ? { id: this.eventID } : undefined,
          fullName,
          emailAddress,
          phoneNumber,
          linkedInURL,
          location,
          source: 'SHARE',
          resume: resume && resume.id ? { id: resume.id } : undefined,
          coverLetter: coverLetter && coverLetter.id ? { id: coverLetter.id } : undefined,
          customAnswers: Array.isArray(customAnswers) && customAnswers.length ? customAnswers : undefined,
          termsAgreed: this.displayApplyTermsAndConditions ? termsAgreed : true,
          shareCode: shareCode || undefined,
        };

        if (this.canEmployeeApply && this.currentUser) {
          create.isInternal = true;

          if (this.currentUser.id === this.userID) {
            create.user = { id: this.currentUser.id };
            create.eventUser = { id: this.currentUser.id };
          } else {
            create.user = { id: this.userID };
            create.eventUser = { id: this.currentUser.id };
          }
        }

        if (this.isProductMadness) {
          this.$assert(this.pmPhoneCodeRef, 'Please select a phone number prefix');
          // Append the phone number prefix to the phone number for consistency
          create.phoneNumber = `${pmPhonePrefixMap[this.pmPhoneCodeRef]}${create.phoneNumber}`;
          // Save the phone code ref for the integration later on
          create.extraData = { ...create.extraData, phoneCodeRef: this.pmPhoneCodeRef };
        }

        if (this.applyThenRedirect && this.useApplicationForwardedEvent) {
          create.status = 'FORWARDED';
        }

        this.$log.debug('JobApplicationCreate', create);

        const { data: { createJobApplication } = {} } = await this.$apollo.mutate({
          mutation: JobApplicationCreateMutation,
          variables: { create },
        });

        this.applyResult = createJobApplication && createJobApplication.id ? true : 'ERR';

        if (this.applyThenRedirect) {
          // For this flow, the customer wants us to store a little information but then redirect the candidate
          this.redirectToATS(true);
        }
      } catch (err) {
        this.$log.error(err);
        if (matchGraphQLError(err, 'extensions.code', 'APPLICATION_ALREADY_EXISTS')) {
          this.applyResult = 'ERR-ALREADY-EXISTS';

          if (this.applyThenRedirect) {
            this.applyResult = true;
            this.redirectToATS(true);
          }
        } else {
          this.applyResult = 'ERR';
        }
      }
    },
    replaceDescription(description) {
      return description
        .replaceAll('<a', '<a target="_blank"')
        .replaceAll('<p', '<p class="mb-0"');
    },
    renderHTML(val) {
      return unescape(val).replaceAll('\n', '');
    }
  },
};
</script>

<style lang="scss">
.share-show-page {
  .card {
    .card-body {
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }

    .card-footer {
      text-align: center;
      h4 {
        vertical-align: middle;
      }
    }

    .job-image {
      display: block;
      max-width: 150px;
      max-height: 150px;
      width: auto;
      height: auto;
    }

    .job-description {
      flex-direction: column;
      h1 {
        font-size: 1.3em;
      }
      h2 {
        font-size: 1.2em;
      }
    }

    .tags {
      display: inline-flex;
      .match-label {
        padding-left: 0.5em;
        padding-right: 0.5em;
        width: inherit;
        font-weight: 400;
        text-transform: inherit;
        margin-right: 0.7em;
        height: inherit;
      }
    }

    margin-bottom: 2em;
  }

  .help-text {
    font-size: 1rem;
  }

  .custom-instructions-alert {
    margin-top: 1em;
    margin-bottom: 1em;
    padding: 1em;
    background-color: #EB7600;
    color: #FFFFFF;
    border: 4px solid #FFBF00;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/jobs/ShareShow.vue